import React from 'react';

export default function CurationCardSkeleton() {
  return (
    <div
      className="flex flex-col gap-4 animate-pulse [content-visibility:auto] [contain-intrinsic-size:400px_620px]"
      aria-hidden="true"
    >
      <div className="w-full aspect-[4/5] rounded-[2rem] border border-[#E5E0D8] bg-[#F0EEEB]" />
      <div className="px-2">
        <div className="h-[15px] w-16 rounded bg-[#E5E0D8]/70 mb-2" />
        <div className="h-[55px] md:h-[66px] flex flex-col justify-start gap-2">
          <div className="h-5 md:h-6 w-11/12 rounded bg-[#E5E0D8]/70" />
          <div className="h-5 md:h-6 w-2/3 rounded bg-[#E5E0D8]/70" />
        </div>
        <div className="mt-2 h-[46px] flex flex-col gap-2">
          <div className="h-3.5 w-full rounded bg-[#E5E0D8]/60" />
          <div className="h-3.5 w-3/4 rounded bg-[#E5E0D8]/60" />
        </div>
      </div>
    </div>
  );
}